import { Button, Col, Container, Row } from 'react-bootstrap';
import { ParallaxBanner, ParallaxProvider } from 'react-scroll-parallax';

// images
import coworking from 'assets/images/hero/coworking2.jpg';

const Hero9 = () => {
    return (
      <section className="position-relative hero-9">
        <div className="hero-top">
          <Container>
            <Row className="py-7">
              <Col>
                <h1 className="hero-title fw-bold">
                  Snap
                  <span className="highlight highlight-info d-inline-block">
                    Ads
                  </span>{" "}
                </h1>

                <p className="mt-3 fs-17">
                  A Subsidiary of{" "}
                  <a href="https://techsnapie.com/">
                    {" "}
                    <span style={{ color: "#ffc800" }}>
                      TechSnapie Solutions
                    </span>{" "}
                  </a>
                </p>
              </Col>
            </Row>
          </Container>
        </div> 
        
        <div className="position-relative">
          <div className="hero-cta">
            <Button variant="info" className="btn-cta">
              <a href="/pages/contact" style={{ color: "white" }}>
                {" "}
                Let's Have Talk
              </a>
            </Button>
          </div>
        </div>
        <div className="hero-bottom">
          <ParallaxProvider>
            <ParallaxBanner
              layers={[
                {
                  image: coworking,
                  speed: -55,
                  style: { backgroundSize: "contain" },
                },
              ]}
              className="hero-image"
            ></ParallaxBanner>
          </ParallaxProvider>
        </div>
      </section>
    );
};

export default Hero9;
